export interface XlsxAnchor {
  documentId: string;
  sha256: string;
  sheet: string;
  range: string;
}

export const xlsxUrl = (anchor: XlsxAnchor) =>
  `/documents/${encodeURIComponent(anchor.documentId)}?${new URLSearchParams({ xlsx: "1", sha256: anchor.sha256, sheet: anchor.sheet, range: anchor.range })}`;

export function anchorFromUrl(url?: string): XlsxAnchor | undefined {
  if (!url || !url.startsWith("/documents/")) return undefined;
  const [path, query] = url.split("?");
  const params = new URLSearchParams(query);
  const documentId = path.slice("/documents/".length);
  const sha256 = params.get("sha256") || "";
  const sheet = params.get("sheet") || "";
  const range = params.get("range") || "";
  if (
    !/^[0-9a-f-]{36}$/i.test(documentId) ||
    !/^[0-9a-f]{64}$/.test(sha256) ||
    !sheet ||
    sheet.length > 31 ||
    !/^[A-Z]{1,3}[1-9][0-9]{0,4}(?::[A-Z]{1,3}[1-9][0-9]{0,4})?$/.test(range)
  )
    return undefined;
  return { documentId, sha256, sheet, range };
}
